module.exports = {
    logo_height: "26",
    EVENT_TYPE: {
        FALL: "Fall"
    },
    MONITOR_STATUS: {
        TOILET: {
            IDLE: "TOILET_IDLE",
            USING: "TOILET_USING",
            USING_OT: "TOILET_USING_OT",
            FALL: "TOILET_FALL",
            FROZEN_FALL: "TOILET_FROZEN_FALL",
            FROZEN_USING_OT: "TOILET_FROZEN_USING_OT",
            NOMOVE: "TOILET_NOMOVE",
            FROZEN_NOMOVE: "TOILET_FROZEN_NOMOVE",
            NO_STATUS: "TOILET_NO_STATUS",
            USING_OT_PAUSED: "TOILET_USING_OT_PAUSED"
        },
        BED: {
            IDLE: "BED_IDLE",
            USING: "BED_USING",
            USING_OT: "BED_USING_OT",
            FALL: "BED_FALL",
            FROZEN_FALL: "BED_FROZEN_FALL",
            FROZEN_USING_OT: "BED_FROZEN_USING_OT",
            NO_STATUS: "BED_NO_STATUS",
            USING_OT_PAUSED: "BED_USING_OT_PAUSED"
        }
    },
    MONITOR_TYPE: {
        TOILET: 2,
        BED: 1
    },
    MONITOR_PERIOD: {
        "24hours": "24hours",
        "MidNight": "MidNight",
        "AppliedRule": "AppliedRule",
        "SelfDefined": "SelfDefined"
    },
    REPORT_PERIOD: {
        M1: "1M",
        M3: "3M",
        M6: "6M",
        ALL: "ALL"
    },
    LOCATION_TYPE: {
        ROOM: "ROOM",
        TOILET: "TOILET"
    },
    DISPLAY_MODE: {
        COLUMN_2: "column_2"
    },
    REPORT_PAGE_SIZE: 10,
    // Max date range (days, inclusive) when a report includes vacant status. 32 = any 1-month range (e.g. default 08-16 ~ 09-16)
    REPORT_INCLUDE_VACANT_MAX_DAYS: 32,
    GENDER: {
        MALE: "M",
        FEMALE: "F",
        ALL: "A"
    },
    SORT: {
        ASE: "asc",
        DESC: "desc"
    },
    HARDWARE_TYPE: {
        LIDAR: 1,
        MMWAVE: 2
    },
    SELECTION_ALL: "ALL",
    ISSUE_STATUS: {
        OPEN: 0,
        CLOSED: 1
    },
    ENV: {
        DEVELOPMENT: "development",
        PRODUCTION: "production",
        STAGE: "stage",
        INTERNAL: "internal"
    }
}